




































































































import { Component, Vue } from 'vue-property-decorator';
import { accountSettingsService } from '@/services/AccountSettingsService';
import { format } from 'date-fns';
import * as sshpk from 'sshpk';

@Component({})
export default class SshKeys extends Vue {
  SSHkeys = [];
  isModalShown = false;
  publicKeyName = '';
  publicKey = '';
  isRemoveSSHKeyModalShown = false;
  deleteSSHKeyId = '';
  deleteSSHKeyName = '';
  isActiveNameValidation = false;
  isActiveSSHKeyValidation = false;
  isInvalidSSHKey = false;
  doesSSHKeyAlreadyExist = false;
  isLoading = false;

  formatDate(date: string) {
    return date ? format(new Date(date), 'dd.MM.yyyy') : '';
  }

  openDeleteSSHKeyDialog(SSHKeyId: string, SSHKeyName: string) {
    this.deleteSSHKeyId = SSHKeyId;
    this.deleteSSHKeyName = SSHKeyName;
    this.isRemoveSSHKeyModalShown = true;
  }

  onCloseRemoveSSHKeyModal() {
    this.isRemoveSSHKeyModalShown = false;
  }

  mounted() {
    this.getSSHKeys();
  }
  getSSHKeys() {
    accountSettingsService.getSshKeys().then((data: any) => {
      this.SSHkeys = data.ssh_keys;
    });
  }

  testKey(key: string) {
    let parsedKey = null;
    try {
      parsedKey = sshpk.parseKey(key, 'auto');
    } catch (e) {
      return false;
    }
    return !!(parsedKey && parsedKey.type);
  }

  deleteSSHKey(sshKeyId: any) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .deleteSshKey(sshKeyId)
      .then(() => {
        this.isLoading = false;
        this.getSSHKeys();
        this.onCloseRemoveSSHKeyModal();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }

  createSSHKey() {
    this.isActiveNameValidation = true;
    this.isActiveSSHKeyValidation = true;
    this.isInvalidSSHKey = false;
    if (
      !this.publicKeyName ||
      (this.publicKeyName && this.publicKeyName.length < 4) ||
      (this.publicKeyName && this.publicKeyName.length > 64) ||
      !this.publicKey ||
      (this.publicKey && !this.testKey(this.publicKey.trim()))
    ) {
      return;
    }

    this.publicKey = this.publicKey.trim();

    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .createSshKey({
        name: this.publicKeyName,
        public_key: this.publicKey,
      })
      .then(() => {
        this.isLoading = false;
        this.getSSHKeys();
        this.cancelSSHKeys();
      })
      .catch((data: any) => {
        this.isLoading = false;
        if (data.status === 422) {
          if (data && data.data && data.status === 422) {
            let error = data.data.error || {};
            if (error.public_key && error.public_key[0] && error.public_key[0].error === 'invalid') {
              this.isInvalidSSHKey = true;
            }
            if (error.public_key && error.public_key[0] && error.public_key[0].error === 'not_unique') {
              this.doesSSHKeyAlreadyExist = true;
            }
          }
        }
      });
  }

  cancelSSHKeys() {
    this.isModalShown = false;
    this.isActiveNameValidation = false;
    this.isActiveSSHKeyValidation = false;
    this.doesSSHKeyAlreadyExist = false;
    this.publicKeyName = '';
    this.publicKey = '';
  }
}
